// extracted by mini-css-extract-plugin
module.exports = {"app":"app_app__cewju","window":"app_window__vaUzZ"};